import User from "./User";

export default class Report {


  /**
   * Returns the maintenance time values as a Date[].
   * @returns {Date[]}
   */
  get maintenanceTimeRange() {
    if (this.maintenanceStart && this.maintenanceEnd) {
      return [new Date(this.maintenanceStart), new Date(this.maintenanceEnd)]
    } else {
      return [];
    }
  }

  /**
   * Sets the Date[] values as ISOStrings for maintenance times
   * @param {Date[]} value
   */
  set maintenanceTimeRange(value) {
    if (Array.isArray(value)) {
      [this.maintenanceStart, this.maintenanceEnd] = value.map(item => item.toISOString())
    } else {
      [this.maintenanceStart, this.maintenanceEnd] = [undefined, undefined];
    }
  }

  /**
   *
   * @param {number} id
   * @param {string} subject
   * @param {string} content
   * @param {WarningOption} warningOption
   * @param {customers[]} customers
   * @param {number} createdAt
   * @param {number} updatedAt
   * @param {User} createdByAccount
   * @param {User} author
   * @param {User} updatedByAccount
   * @param {string} updatedBy
   * @param {string} maintenanceStart
   * @param {string} maintenanceEnd
   * @param {ReportUpdate[]} updates
   * @param {User} textUpdatedByAccount
   * @param {string} textUpdatedBy
   * @param {string} textUpdatedDate
   * @param {string} createdByName
   * @param {string} createdByEmail
   * @param {string} updatedByName
   * @param {string} updatedByEmail
   * @param {string} textUpdatedByName
   * @param {string} textUpdatedByEmail
   */
  constructor(id, subject, content, warningOption, customers,
              createdAt, updatedAt, createdByAccount, author, updatedByAccount, updatedBy,
              maintenanceStart, maintenanceEnd, updates, textUpdatedByAccount, textUpdatedBy,
              textUpdatedDate, createdByName, createdByEmail, updatedByName,updatedByEmail,
              textUpdatedByName, textUpdatedByEmail
              ) {
    /**
     * TODO
     * @type {number}
     */
    this.id = id;

    /**
     * TODO use current logged in user for default
     * @type {User}
     */
    this.author = author || new User(0, '28Apps');

    /**
     * @type {string}
     */
    this.subject = subject || '';

    /**
     * @type {string}
     */
    this.content = content || '';

    /**
     * @type {WarningOption}
     */
    this.warningOption = warningOption;

    /**
     * @type {Customer[]}
     */
    this.customers = customers || [];

    /**
     * Timestamp
     * @type {number}
     */
    this.createdAt = createdAt;

    /**
     * @type {string}
     */
    this.updatedBy = updatedBy;

    /**
     * Timestamp
     * @type {number}
     */
    this.updatedAt = updatedAt;

    /**
     * @type {User}
     */
    this.createdByAccount = createdByAccount;

    /**
     * @type {User}
     */
    this.updatedByAccount = updatedByAccount;

    /**
     * @type {string}
     */
    this.maintenanceStart = maintenanceStart;

    /**
     * @type {string}
     */
    this.maintenanceEnd = maintenanceEnd;

    /**
     * @type {ReportUpdate[]}
     */
    this.updates = updates || [];

    /**
     * @type{string}
     */
    this.textUpdatedBy = textUpdatedBy;

    /**
     * @type{string}
     */
    this.textUpdatedDate = textUpdatedDate;

    /**
     * @type{User}
     */
    this.textUpdatedByAccount = textUpdatedByAccount;

    /**
     * @type{string}
     */
    this.createdByName = createdByName;

    /**
     * @type{string}
     */
    this.createdByEmail = createdByEmail;

    /**
     * @type{string}
     */
    this.updatedByName = updatedByName;
    /**
     * @type{string}
     */
    this.updatedByEmail = updatedByEmail;
    /**
     * @type{string}
     */
    this.textUpdatedByName = textUpdatedByName;
    /**
     * @type{string}
     */
    this.textUpdatedByEmail = textUpdatedByEmail;
  }
}
